import { useMemo } from "react";

import AtlasContent from "atlas-content/atlas-content.json";
import { useUserDataContext } from "context/UserDataContext";
import { IAnsweredQuizzes, IAtlasContent } from "types/types";

export const AVAILABLE_QUIZZES = [
  "bitcoin-intro",
  "bitcoin-pro-zacatecniky-s-bitcoinerkou-zuzkou",
  "proc-bitcoin-s-kicomem",
  "ekonomie-bitcoinu",
  "technologie-bitcoinu",
  "nakup-a-prodej-bitcoinu",
  "uschova-a-pouzivani-bitcoinu",
  "bezpecnost-a-podvody",
  "dalsi-temata-a-zdroje",
];

function useAreasProgress(atlasContent: IAtlasContent, answeredQuizzes?: IAnsweredQuizzes) {
  return useMemo(() => {
    const result: Record<string, { max: number; done: number; title: string }> = {};

    Object.entries(atlasContent.areas).forEach(([areaKey, areaValue]) => {
      let max = 0;
      let done = 0;

      areaValue.modules.forEach((module) => {
        module.chapters.forEach((chapter) => {
          if (chapter.quiz && chapter.quiz.xpReward) {
            max += chapter.quiz.xpReward;
            if (answeredQuizzes?.urls.includes(chapter.url)) {
              done += chapter.quiz.xpReward;
            }
          }
        });
      });

      result[areaKey] = {
        max,
        done,
        title: areaValue.title,
      };
    });

    return result;
  }, [atlasContent, answeredQuizzes]);
}

const useAtlasData = () => {
  const { answeredQuizzes } = useUserDataContext();
  const areasProgress = useAreasProgress(AtlasContent as IAtlasContent, answeredQuizzes);

  const { totalMax, totalDone } = useMemo(() => {
    let totalMax = 0;
    let totalDone = 0;
    AVAILABLE_QUIZZES.forEach((areaKey) => {
      const area = areasProgress[areaKey];
      if (area) {
        totalMax += area.max;
        totalDone += area.done;
      }
    });
    return { totalMax, totalDone };
  }, [areasProgress]);

  return {
    areasProgress,
    totalMax,
    totalDone,
    answeredQuizzes,
  };
};

export default useAtlasData;
